<template>
  <div class="sso-callback">
    <p v-if="error" class="sso-callback__error">{{ error }}</p>
    <p v-else>Signing in…</p>
  </div>
</template>

<script>
import { onMounted, ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";
import {
  finishBackend2Login,
  startBackend2Login,
  startSsoRefresh,
} from "../shared/ssoAuth";

export default {
  name: "SsoCallback",
  setup() {
    const route = useRoute();
    const router = useRouter();
    const store = useStore();
    const error = ref("");

    onMounted(async () => {
      const accessToken = route.query.accessToken;
      const realm = route.query.realm;
      const logoutToken = route.query.logoutToken;
      const requested =
        typeof route.query.return_path === "string" ? route.query.return_path : "/";
      const returnPath =
        requested.startsWith("/") && !requested.startsWith("//") ? requested : "/";

      if (!accessToken || !realm) {
        error.value = "Missing SSO callback parameters.";
        startBackend2Login();
        return;
      }

      try {
        const session = await finishBackend2Login({
          realm,
          accessToken,
          logoutToken,
        });
        store.dispatch("setAccessToken", session.accessToken);
        startSsoRefresh((token) => store.dispatch("setAccessToken", token));
        await router.replace(returnPath || "/");
      } catch (e) {
        error.value = e.message || "Could not finish login.";
      }
    });

    return { error };
  },
};
</script>

<style scoped>
.sso-callback {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #0b1220;
  color: #e8eef7;
  font-family: "IBM Plex Sans", "Segoe UI", sans-serif;
}

.sso-callback__error {
  color: #fca5a5;
  max-width: 32rem;
  padding: 1rem;
}
</style>
